export type AppConfig = {
   apiPrefix: string
   companyAuthenticatedEntryPath: string
   accountantAuthenticatedEntryPath: string
   unAuthenticatedEntryPath: string
   tourPath: string
   locale: string
   enableMock: boolean
}

const appConfig: AppConfig = {
   apiPrefix: '/api',
   companyAuthenticatedEntryPath: '/~company~/books/journals',
   accountantAuthenticatedEntryPath: '/~accountant~/module_selector',
   unAuthenticatedEntryPath: '/sign-in',
   tourPath: '/',
   locale: 'en',
   enableMock: false,
}

export default appConfig
